var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.23,
    height: 29.23,
    viewBox: "0 0 29.23 29.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "LinkedInWhiteLogo",
    d: "M24.9,24.907H20.577V18.129c0-1.62-.037-3.7-2.259-3.7-2.253,0-2.6,1.76-2.6,3.581v6.9h-4.33V10.961h4.159v1.9H15.6a4.571,4.571,0,0,1,4.1-2.253c4.385,0,5.2,2.887,5.2,6.644v7.655ZM6.5,9.055A2.515,2.515,0,1,1,9.013,6.54,2.514,2.514,0,0,1,6.5,9.055ZM8.672,24.907H4.33V10.961H8.672ZM27.069,0H2.156A2.13,2.13,0,0,0,0,2.107V27.123A2.13,2.13,0,0,0,2.156,29.23H27.063a2.141,2.141,0,0,0,2.168-2.107V2.107A2.141,2.141,0,0,0,27.063,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInWhiteLogo);
export default __webpack_public_path__ + "static/media/LinkedInWhiteLogo.ad5f8f22ce5845d1b1da37acf6eda8d6.svg";
export { ForwardRef as ReactComponent };